import {
    getDevicePlatform,
    getUserConsent
} from '@dazn/lp-web/src/utils/bootstrap';
import {
    ADV_TV_CONSENT,
    consentType
} from '@dazn/lp-web/src/constants/consentTypes.constants';

export const checkIfSponsorshipLogoEnabled = (): boolean => {
    try {
        const isFeatureEnabled = Boolean(
            window.dazn.features.isEnabledAnonymous('f_sponsorship_ads')
        );
        return isFeatureEnabled;
    } catch (e) {
        return false;
    }
};

export const getLogoSlotPath = (): string => {
    if (checkIfSponsorshipLogoEnabled()) {
        return String(
            window.dazn.features.getVariableStringAnonymous(
                'f_sponsorship_ads',
                'ad_units'
            )
        );
    }
    return '';
};

export const getIsNativePlatform = (platform: string): boolean => {
    try {
        const nativePlatform = String(
            window.dazn.features.getVariableStringAnonymous(
                'f_sponsorship_ads',
                'native_platform'
            )
        );
        return nativePlatform === ''
            ? false
            : nativePlatform.split(',').includes(platform);
    } catch (e) {
        return false;
    }
};

export const checkIfSSAdsEnabledForLP = (nativeAppName: string): boolean => {
    try {
        const landingPage = String(
            window.dazn.features.getVariableStringAnonymous(
                'f_sponsorship_ads',
                'landing_pages'
            )
        );
        return landingPage === ''
            ? false
            : landingPage.split(',').includes(nativeAppName);
    } catch (e) {
        return false;
    }
};

export const getDeviceCategory = (): string => {
    switch (getDevicePlatform()) {
        case 'tizen':
        case 'webos':
        case 'xboxone':
        case 'ps5':
        case 'sky':
        case 'viera':
        case 'vidaa':
            return 'tv';
        case 'web':
            return 'web';
        default:
            return '';
    }
};

/**
 *
 * npa=1, ltd=0 ADV_TV_TV_CONSENT=NPA
 * npa=0, ltd=1 ADV_TV_TV_CONSENT=LTD
 * npa=1, ltd=1 ADV_TV_TV_CONSENT=Reject
 * npa=0, ltd=0 ADV_TV_TV_CONSENT=Accept
 *
 * @param gdpr
 * @param ltd
 * @param npa
 * @returns
 */
export const getConsent = (
    gdpr: boolean | number | string,
    ltd: boolean | number | string,
    npa: boolean | number | string
): string => {
    if (gdpr) {
        return ADV_TV_CONSENT.GDPR;
    }
    if (npa && ltd) {
        return ADV_TV_CONSENT.REJECT;
    } else if (npa) {
        return ADV_TV_CONSENT.NPA;
    } else if (ltd) {
        return ADV_TV_CONSENT.LTD;
    }

    return ADV_TV_CONSENT.ACCEPT;
};

const isTcfWebEnabled = (): boolean => {
    const isTcfEnabled =
        getDeviceCategory() === 'web'
            ? window.dazn.features.getVariableBooleanAnonymous(
                  'f_tcf_enablement_web',
                  'isTcfEnabled'
              )
            : window.dazn.features.getVariableBooleanAnonymous(
                  'f_tcf_enablement_lrd',
                  'isTcfEnabled'
              );

    return isTcfEnabled === true;
};

export const checkUserConsent = async (): Promise<string> => {
    const userConsent = await getUserConsent();
    if (userConsent.gdprConsent && isTcfWebEnabled()) {
        consentType.GDPR_CONSENT = userConsent.gdprConsent;
        consentType.GDPR = '1';

        return getConsent(consentType.GDPR, false, false);
    } else {
        consentType.LTD = userConsent.googleAdsStorage ? '0' : '1';
        consentType.NPA = userConsent.personalisedAds ? '0' : '1';

        return getConsent(false, consentType.LTD, consentType.NPA);
    }
};
